export default {"src":"/_next/static/media/gyro-short.77ee2bb5.svg","height":75,"width":257};